import { render, staticRenderFns } from "./SaleBigScreen.vue?vue&type=template&id=3826ae86&scoped=true&"
import script from "./SaleBigScreen.vue?vue&type=script&lang=js&"
export * from "./SaleBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./SaleBigScreen.vue?vue&type=style&index=0&id=3826ae86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3826ae86",
  null
  
)

export default component.exports